import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Responsive, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { logout } from 'libraries/api-service';
import jsCookie from 'js-cookie';

import { clearUserDidLogin, setIsLoggingOut } from 'store/actions/session';
import { clearTransactions } from 'store/actions/transactions';
import { clearTransactions as clearClientTransactions } from 'store/actions/clientTransactions';
import { clearOnboarding } from 'store/actions/onboarding';
import { clearPlaidEnvironment } from 'store/actions/plaid';
import { clearSubscription } from 'store/actions/subscription';
import { clearPnlData } from 'store/actions/profitAndLoss';

import './styles.scss';
import Routes from 'routes';
import withNotifications from 'components/hocs/WithNotifications';
import LoggedOutMenu from './LoggedOutMenu';

/**
 * Presents menu options to a user that has signed-in.
 *
 * This version of the component is exclusively used for dashboards
 * where a user with a professional account type has logged in.
 */
class HeaderProfileMenuv2 extends React.Component {
  state = {
    isMobile: false,
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateIsMobile(window.innerWidth));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile(window.innerWidth));
  }

  updateIsMobile = (width) => {
    this.setState({ isMobile: width < Responsive.onlyTablet.minWidth });
  }

  handleSignOut = () => {
    const {
      history,
      pushNotification,
    } = this.props;
    setIsLoggingOut(true);
    logout()
      .then(() => {
        jsCookie.remove('active_client_email');
        jsCookie.remove('active_client_form_name');
        jsCookie.remove('active_client_full_name');

        this.props.clearTransactions();
        this.props.clearClientTransactions();
        this.props.clearUserDidLogin();
        this.props.clearOnboarding();
        this.props.clearPlaidEnvironment();
        this.props.clearPnlData();
        this.props.clearSubscription();
        history.push(Routes.Index);
      })
      .catch((err) => {
        pushNotification(
          'ERROR_LOGGING_OUT',
          'Error logging out',
          err.message,
          'error',
          5000,
        );
      })
      .finally(() => {
        this.props.setIsLoggingOut(false);
      });
  };

  isActive = (key) => {
    const { location: { pathname } } = this.props;
    return !!pathname.match(key);
  };

  getOptions = () => {
    const {
      history,
      location,
      onboarding,
      userProfile: { fullName },
    } = this.props;

    const userNameOption = [{
      key: 'User_mobile',
      text: '',
      content: (
        <>
          Logged as
          <br />
          <i>{this.getShortedName(fullName)}</i>
        </>),
      disabled: true,
    }];

    const commonOptions = [
      {
        key: 'Header_Logout',
        text: 'Log out',
        onClick: () => this.handleSignOut(),
      },
    ];
    const mobileOptions = [
      {
        key: 'mobile_reports',
        text: 'Reports',
        onClick: () => history.push(Routes.DashboardReports),
        selected: this.isActive('/reports'),
        active: this.isActive('/reports'),
      },
    ];
    const dashboardOption = [{
      key: 'lp_dashboard',
      text: 'Dashboard',
      onClick: () => history.push(Routes.ClientDashboardClients),
      selected: this.isActive('/client-dashboard/clients'),
      active: this.isActive('/client-dashboard/clients'),
    }];

    const { isMobile } = this.state;

    return [
      ...(isMobile ? userNameOption : []),
      ...((location.pathname === Routes.Index || isMobile) ? dashboardOption : []),
      ...(isMobile ? mobileOptions : []),
      ...commonOptions,
    ];
  }

  getShortedName = (fullName) => {
    // if username has its text separated by spaces it means it has a lastname
    // if user has lastname we return name + lastname
    // if it's just 1 word, return first 10 chars.
    const splittedName = fullName.split(/\s/);
    const hasLastname = splittedName.length >= 2;
    if (hasLastname) {
      return `${splittedName[0]} ${splittedName[1]}`;
    }
    return fullName.slice(0, 10);
  };

  getMenuTrigger = () => {
    if (this.state.isMobile) return (<Icon name="bars" />);
    const { userProfile: { fullName } } = this.props;
    return this.getShortedName(fullName);
  }

  render() {
    const { userProfile: { fullName } } = this.props;
    const { isMobile } = this.state;
    return (
      fullName
        ? (
          <Dropdown
            item
            trigger={this.getMenuTrigger()}
            selectOnNavigation={false}
            selectOnBlur={false}
            options={this.getOptions()}
            icon={null}
            pointing={isMobile ? 'top right' : 'top'}
            className="Dashboard__Avatar--menu"
          />
        )
        : (
          <LoggedOutMenu />
        )
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  onboarding: state.session.userInfo.onboarding,
  userProfile: state.session.userProfile,
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => bindActionCreators({
  clearUserDidLogin,
  clearOnboarding,
  clearPlaidEnvironment,
  clearTransactions,
  clearClientTransactions,
  clearPnlData,
  setIsLoggingOut,
  clearSubscription,
}, dispatch);

const wrapperComponent = withRouter(withNotifications(HeaderProfileMenuv2));
export default connect(mapStateToProps, mapDispatchToProps)(wrapperComponent);
